<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.92308C0 4.41328 0.410406 4 0.916667 4H10.0833C10.5896 4 11 4.41328 11 4.92308V15.0769C11 15.5867 10.5896 16 10.0833 16H0.916667C0.410406 16 0 15.5867 0 15.0769V4.92308ZM1.83333 5.84615V14.1538H9.16667V5.84615H1.83333Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 0.88C5 0.393989 5.41041 0 5.91667 0H15.0833C15.5896 0 16 0.393989 16 0.88V10.12C16 10.606 15.5896 11 15.0833 11H13.25C12.7437 11 12.3333 10.606 12.3333 10.12C12.3333 9.63399 12.7437 9.24 13.25 9.24H14.1667V1.76H6.83333V2.64C6.83333 3.12601 6.42293 3.52 5.91667 3.52C5.41041 3.52 5 3.12601 5 2.64V0.88Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCopy",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
